// extracted by mini-css-extract-plugin
export default {"iconContainer":"Subheader_iconContainer__464Mt"};